import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function themeReducer(state = initialState.theme, action) {
    switch (action.type) {
        case types.LOAD_THEME_SUCCESS:
            return {
                ...state,
                loaded: true,
                data: action.theme,
                error: null
            };
        case types.LOAD_THEME_ERROR:
            return {
                ...state,
                loaded: true,
                error: action.error
            };
        default:
            return state;
    }
}
